export default __webpack_public_path__ + "static/media/foto4.0b63e908.webp";